import clsx from "clsx";
import { ReactElement, ReactNode } from "react";

interface IProps {
    list: any[];
    columns: string[];
    accessors: string[];
    getListItemElement: (item: Record<string, any>, accessor: string, index: number) => ReactNode;
}

export default function List(props: IProps) {

    return (
        <div
            className="bg-white dark:bg-primary-dark-surface rounded-xl shadow overflow-hidden">

            {/* New view with table */}
            <div className="hidden md:block overflow-x-auto">
                <table className="w-full">
                    <thead className="bg-gray-50 dark:bg-primary-dark-secondary border-b border-gray-100 dark:border-primary-dark-border_active">
                        <tr>
                            {props.columns?.map((column: string, index: number) => (
                                <th
                                    key={index}
                                    className={clsx(
                                        "text-left text-sm font-medium text-gray-500 dark:text-text-dark-primary px-6 py-4",
                                        { ["!text-right"]: index === props.columns.length - 1 && column.toLowerCase().includes("action") }
                                    )}>
                                    {column}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100 dark:divide-primary-dark-border_active">

                        {/* Member Row */}
                        {props.list?.map((item: any, index: number) => (
                            <tr
                                key={index}
                                className="hover:bg-gray-50 hover:dark:bg-primary-dark-border_active transition"
                            >
                                {props.accessors.map((accessor: string, indx: number) => (
                                    <td
                                        key={indx}
                                        className="px-6 py-5 text-sm text-gray-700 dark:text-text-dark-primary"
                                    >
                                        {props.getListItemElement(item, accessor, index)}
                                    </td>
                                ))}
                            </tr>
                        ))}

                    </tbody>
                </table>
            </div>
            {/* New view with table */}

            {/* Mobile Cards */}
            <div className="md:hidden divide-y divide-gray-100 dark:divide-primary-dark-border_active">
                {props.list?.map((item: any, index: number) => (
                    <div
                        key={index}
                        className="p-5 space-y-4"
                    >
                        {/* Details */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                            {props.accessors.map((accessor: string, indx: number) => (
                                <div key={indx}>
                                    {!props.columns[indx]?.toLowerCase().includes("action") && (
                                        <p className="text-gray-400 dark:text-text-dark-secondary">{props.columns[indx]}</p>
                                    )}

                                    <div className="text-gray-700 dark:text-text-dark-primary font-medium">
                                        {props.getListItemElement(item, accessor, index)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}